export default "__VITE_ASSET__CbwuxhGs__"